import { getDataClient } from "@/lib/dataClient";

// İki faktörlü doğrulama (2FA / TOTP) — dataClient MFA API sarmalayıcısı.

export interface MfaFactor {
  id: string;
  type: string;
  friendlyName: string | null;
}

export interface MfaEnrollResult {
  id: string;
  type: string;
  qrCode: string;
  secret: string;
  uri: string;
}

// Kayıtlı faktörleri listeler (totp + phone).
export async function listMfaFactors(): Promise<{ totp: MfaFactor[]; phone: MfaFactor[] }> {
  const dataClient = getDataClient();
  const { data, error } = await dataClient.auth.mfa.listFactors();
  if (error) throw error;
  const map = (arr: { id: string; factor_type: string; friendly_name?: string | null }[] = []): MfaFactor[] =>
    (arr ?? []).map((f) => ({
      id: f.id,
      type: f.factor_type,
      friendlyName: f.friendly_name ?? null,
    }));
  return { totp: map(data?.totp), phone: map(data?.phone) };
}

// Yeni bir TOTP faktörü kaydını başlatır (QR kodu + gizli anahtar döndürür).
export async function enrollMfaTotp(friendlyName = "DersDinle"): Promise<MfaEnrollResult> {
  const dataClient = getDataClient();
  const { data, error } = await dataClient.auth.mfa.enroll({ factorType: "totp", friendlyName });
  if (error) throw error;
  return {
    id: data.id,
    type: data.type,
    qrCode: data.totp?.qr_code ?? "",
    secret: data.totp?.secret ?? "",
    uri: data.totp?.uri ?? "",
  };
}

// Faktör için doğrulama sınaması (challenge) başlatır ve challenge id döndürür.
export async function challengeMfa(factorId: string): Promise<string> {
  const dataClient = getDataClient();
  const { data, error } = await dataClient.auth.mfa.challenge({ factorId });
  if (error) throw error;
  return data?.id ?? "";
}

// Girilen kodu doğrular.
export async function verifyMfa(factorId: string, challengeId: string, code: string): Promise<void> {
  const dataClient = getDataClient();
  const { error } = await dataClient.auth.mfa.verify({ factorId, challengeId, code });
  if (error) throw error;
}

// Kayıtlı bir faktörü kaldırır.
export async function unenrollMfa(factorId: string): Promise<void> {
  const dataClient = getDataClient();
  const { error } = await dataClient.auth.mfa.unenroll({ factorId });
  if (error) throw error;
}

// Kullanıcının kayıtlı, doğrulanmış bir TOTP faktörü olup olmadığını kontrol eder.
export async function hasVerifiedTotp(): Promise<{ has: boolean; factorId: string }> {
  try {
    const { totp } = await listMfaFactors();
    const verified = totp.filter((f) => f.type === "totp");
    return { has: verified.length > 0, factorId: verified[0]?.id ?? "" };
  } catch {
    return { has: false, factorId: "" };
  }
}
